import { useEffect } from 'react';
import TokenService from '@/services/TokenService/TokenService';

export const usePagePersistedLoad = () => {
  useEffect(() => {
    window.onpageshow = (event) => {
      const token = TokenService.getTokenData();
      if (event.persisted && !token) window.location.reload();
    };
  }, []);
};
